

export const isLocalHost = () => {
	return (window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1");
}

export const capitalizeWord = (word) => {
	return word.charAt(0).toUpperCase() + word.slice(1);
}

export const isEmail = (email) => {
	const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  };

export const numberWithCommas = function(num) {
	return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

export const deepCopyFunction = (inObject) => {
	let outObject, value, key

	if (typeof inObject !== "object" || inObject === null) {
		return inObject // Return the value if inObject is not an object
	}

	// Create an array or object to hold the values
	outObject = Array.isArray(inObject) ? [] : {}

	for (key in inObject) {
		value = inObject[key]

		// Recursively (deep) copy for nested objects, including arrays
		outObject[key] = deepCopyFunction(value)
	}

	return outObject
}

export const detectDeviceType = () => {
	return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
    ? 'mobile'
    : 'desktop';
	//console.log(detectDeviceType()); // "Mobile" or "Desktop"
}

export const removeDuplicateCharacters = (string) => {
	return string
	  .split('')
	  .filter(function(item, pos, self) {
		return self.indexOf(item) == pos;
	  })
	  .join('');
  }

export const facebookShare = function(appId, shareImage, shareURL, shareMsg, shareRedirectURI){
	
	var url = "https://www.facebook.com/dialog/feed";
	url += "?app_id=" + appId;
	url += "&description=" + encodeURIComponent(shareMsg);
	url += "&picture=" + encodeURIComponent(shareImage);
	url += "&link=" + encodeURIComponent(shareURL);
	url += "&redirect_uri=" + encodeURIComponent(shareRedirectURI);
	url += "&display=popup";

	window.open(url, "_blank");

}

export const facebookSharer = function(shareURL){
	var url = "https://www.facebook.com/sharer.php";
	url += "?u=" + shareURL;
	url += "&utm_source=facebook&utm_medium=social&utm_campaign=social_share&utm_id=asdiy";

	window.open(url, "_blank");
}

export const twitterShare = function(shareMsg, shareURL){

	var url = "https://twitter.com/intent/tweet";
	url += "?text=" + encodeURIComponent(shareMsg);
	url += "&url=" + encodeURIComponent(shareURL);
	url += "&utm_source=twitter&utm_medium=social&utm_campaign=social_share&utm_id=asdiy";

	window.open(url, "_blank");
}


// WEBPACK FOOTER //
// ./src/js/utils/utils.js